import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-714e1c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-flex tw-flex-col" }
const _hoisted_3 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col md:tw-flex-row tw-items-center" }
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-gap-1 tw-text-left tw-px-2" }
const _hoisted_5 = { class: "tw-select-none tw-text-xs" }
const _hoisted_6 = {
  key: 1,
  class: "tw-py-1 mt-1 tw-block"
}
const _hoisted_7 = { style: {"color":"var(--primary-color)"} }
const _hoisted_8 = { style: {"text-transform":"capitalize"} }
const _hoisted_9 = { style: {"text-transform":"capitalize"} }
const _hoisted_10 = { class: "md:tw-ml-auto tw-mt-4 md:tw-mt-0 md:tw-space-y-1" }
const _hoisted_11 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Descargar")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"1.8rem"},
  class: "pi pi-file-pdf"
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { style: {} }
const _hoisted_16 = {
  key: 1,
  class: "tw-select-none tw-border tw-border-red-500 tw-p-1 tw-rounded tw-flex tw-items-center tw-justify-between tw-px-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(239, 68, 68)"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Vencida")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-2 mt-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "tw-w-full" }, null, -1))
const _hoisted_21 = { class: "tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-sm tw--mb-6 tw-text-indigo-500 tw-cursor-pointer" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "tw-w-full" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Aceptar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_receta_info = _resolveComponent("receta-info")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "p-shadow-5 tw-h-full" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (!!_ctx.estado)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "tw-px-2 tw-py-1 tw-rounded tw-shadow",
                      style: _normalizeStyle(`
                                        --estado-color:${_ctx.estado.color || "#fafafa"};
                                        outline: 1px solid lch(from var(--estado-color) l calc(c + 10) h);
                                        background-color:lch(from var(--estado-color) l c h / 5%);
                                        color:lch(from var(--estado-color) l calc(c + 10) h);
                                    `)
                    }, _toDisplayString(_ctx.estado.descripcion), 5))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6))
              ]),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.fecha), 1)
              ]),
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("strong", null, "Dr. " + _toDisplayString(_ctx.medico.toLowerCase()), 1)
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.especialidad.toLowerCase()), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.isDescargable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: _normalizeClass([{"btn--loading":_ctx.isLoading, "tw-bg-transparent tw-text-primary":!_ctx.isLoading}, "tw-select-none tw-cursor-pointer tw-border tw-p-1 tw-rounded tw-flex tw-items-center tw-justify-between"]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.isLoading && _ctx.$emit("descargar",_ctx.auditoria)))
                    }, _hoisted_14, 2),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_15, [
                        _createElementVNode("strong", null, "Venc.: " + _toDisplayString(_ctx.fechaVencimiento), 1)
                      ])
                    ])
                  ]))
                : (_ctx.isVencida)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraItems, (item, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: item,
                  onClick: item.command,
                  class: _normalizeClass(["tw-select-none tw-flex tw-gap-2 tw-items-center", {"tw-border-l tw-border-indigo-500 tw-pl-2":index }])
                }, [
                  _createElementVNode("a", null, _toDisplayString(item.label), 1),
                  _createElementVNode("i", {
                    class: _normalizeClass([item.icon,"tw-text-xs tw-font-semibold"])
                  }, null, 2)
                ], 10, _hoisted_22))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      closable: true,
      modal: true,
      appendTo: "self",
      header: "Información",
      visible: _ctx.showInfo,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showInfo) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_Button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showInfo = false))
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.showInfo)
          ? (_openBlock(), _createBlock(_component_receta_info, {
              key: 0,
              id: _ctx.dato._id
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}